
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5338"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5338"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $2a18793cda52bce4$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["hvItV","index.64bf9bfb.js","2QpcM","banner_twitter.d6d5a4a2.png","hmzIO","banner.b8b88c77.png"]'));

// @ts-ignore
var $a1e313bc32d70fd0$exports = {};
$a1e313bc32d70fd0$exports = new URL("banner_twitter.d6d5a4a2.png", import.meta.url).toString();


var $1cc07a71e22814e0$exports = {};
$1cc07a71e22814e0$exports = new URL("banner.b8b88c77.png", import.meta.url).toString();


var $4c0f0ee047d80e21$export$e0112074983e541d;
(function(GeneratorMode) {
    GeneratorMode["DEFAULT"] = "DEFAULT";
    GeneratorMode["TWITTER"] = "TWITTER";
})($4c0f0ee047d80e21$export$e0112074983e541d || ($4c0f0ee047d80e21$export$e0112074983e541d = {}));
const $4c0f0ee047d80e21$var$generatorConfigMap = new Map([
    [
        "DEFAULT",
        {
            height: 384,
            width: 1152,
            backgroundImage: (0, (/*@__PURE__*/$parcel$interopDefault($1cc07a71e22814e0$exports)))
        }
    ],
    [
        "TWITTER",
        {
            width: 1024,
            height: 512,
            backgroundImage: (0, (/*@__PURE__*/$parcel$interopDefault($a1e313bc32d70fd0$exports)))
        }
    ]
]);
class $4c0f0ee047d80e21$export$a97837e312619932 {
    constructor(mode, baseText){
        const config = $4c0f0ee047d80e21$var$generatorConfigMap.get(mode);
        if (!config) throw new Error(`no config found for key ${mode}`);
        this.config = config;
        this.canvasPreviewContainerElement = this.getCanvasPreviewContainerElement();
        this.canvasImageBackgroundContainer = this.getCanvasImageBackgroundContainerElement();
        this.canvasPreviewElement = this.buildCanvasPreviewElement();
        this.canvasImageBackground = this.buildImageBackgroundElement();
        if (baseText) this.updateText(baseText);
    }
    async generatePNGWithText(text, filename = "hsv.png") {
        let canvas = document.createElement("canvas");
        canvas.height = this.config.height;
        canvas.width = this.config.width;
        const context = canvas.getContext("2d");
        if (!context) throw new Error("cannot build context during png generation");
        const img = await new Promise((res, rej)=>{
            const img = document.createElement("img");
            img.src = this.config.backgroundImage;
            img.addEventListener("load", ()=>{
                res(img);
            });
            img.addEventListener("error", (error)=>{
                rej(error);
            });
        });
        context.drawImage(img, 0, 0);
        this.drawTextOnto2DContext(text, context);
        canvas.toBlob((blob)=>{
            if (blob === null) return;
            let data = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.href = data;
            link.download = filename;
            link.click();
        }, "image/png");
        img.remove();
        canvas.remove();
    }
    updateText(text) {
        this.resetPreviewCanvas();
        const context = this.getCanvasPreviewElementOrThrow().getContext("2d");
        if (!context) throw new Error("cannot get canvas context");
        this.drawTextOnto2DContext(text, context);
    }
    destroy() {
        this.getCanvasPreviewElementOrThrow().remove();
        this.getCanvasImageBackgroundElementOrThrow().remove();
    }
    show() {
        this.getCanvasPreviewElementOrThrow().hidden = false;
    }
    hide() {
        this.getCanvasPreviewElementOrThrow().hidden = true;
    }
    drawTextOnto2DContext(text, context) {
        let parts = text.split(String.fromCharCode(10));
        context.font = "56px Righteous";
        for(let i = 0; i < parts.length; i++)context.fillText(parts[i], 340, 180 + i * 64);
    }
    buildCanvasPreviewElement() {
        if (this.canvasPreviewElement !== undefined) throw new Error("canvas is already built");
        let canvas = document.createElement("canvas");
        canvas.height = this.config.height;
        canvas.width = this.config.width;
        this.canvasPreviewContainerElement.appendChild(canvas);
        return canvas;
    }
    buildImageBackgroundElement() {
        if (this.canvasImageBackground !== undefined) throw new Error("canvas image background is already built");
        let img = document.createElement("img");
        img.src = this.config.backgroundImage;
        this.canvasImageBackgroundContainer.appendChild(img);
        return img;
    }
    getCanvasPreviewElementOrThrow() {
        if (this.canvasPreviewElement) return this.canvasPreviewElement;
        throw new Error("canvas isn't initialized.");
    }
    getCanvasImageBackgroundElementOrThrow() {
        if (this.canvasImageBackground) return this.canvasImageBackground;
        throw new Error("canvas image background isn't initialized.");
    }
    getCanvasPreviewContainerElement() {
        const container = document.getElementById("canvas-container");
        if (!(container instanceof HTMLDivElement)) throw new Error("canvas-container no found by html id");
        return container;
    }
    getCanvasImageBackgroundContainerElement() {
        const container = document.getElementById("image-background-container");
        if (!(container instanceof HTMLDivElement)) throw new Error("image-background-container no found by html id");
        return container;
    }
    resetPreviewCanvas() {
        const context = this.getCanvasPreviewElementOrThrow().getContext("2d");
        context?.clearRect(0, 0, this.config.width, this.config.height);
    }
}


let $f43313d21d3fd8e2$var$lastInput = "";
const $f43313d21d3fd8e2$var$urlParams = new URLSearchParams(window.location.search);
let $f43313d21d3fd8e2$var$mode = $f43313d21d3fd8e2$var$urlParams.get("mode") === "twitter" ? (0, $4c0f0ee047d80e21$export$e0112074983e541d).TWITTER : (0, $4c0f0ee047d80e21$export$e0112074983e541d).DEFAULT;
let $f43313d21d3fd8e2$var$canvas = new (0, $4c0f0ee047d80e21$export$a97837e312619932)($f43313d21d3fd8e2$var$mode);
const $f43313d21d3fd8e2$var$switchMode = (_mode)=>{
    $f43313d21d3fd8e2$var$canvas.destroy();
    $f43313d21d3fd8e2$var$mode = _mode;
    $f43313d21d3fd8e2$var$canvas = new (0, $4c0f0ee047d80e21$export$a97837e312619932)($f43313d21d3fd8e2$var$mode, $f43313d21d3fd8e2$var$lastInput);
};
const $f43313d21d3fd8e2$var$boot = async ()=>{
    let inputContainer = document.getElementById("input-container");
    if (inputContainer === null) {
        console.error("input container not found");
        return;
    }
    inputContainer.hidden = false;
    const input = document.getElementById("input");
    input?.addEventListener("input", async (event)=>{
        if (!(event.target instanceof HTMLTextAreaElement)) return;
        const text = event.target.value.trim();
        $f43313d21d3fd8e2$var$canvas.updateText(text);
        $f43313d21d3fd8e2$var$lastInput = text;
    });
    const generate = async ()=>{
        await $f43313d21d3fd8e2$var$canvas.generatePNGWithText($f43313d21d3fd8e2$var$lastInput);
        if ($f43313d21d3fd8e2$var$mode === (0, $4c0f0ee047d80e21$export$e0112074983e541d).TWITTER) {
            const params = new URLSearchParams({
                text: "I have contracted $HERPES, i'm sick of Love.",
                url: "https://getherp.es",
                hashtags: "KASPA,KRC20,HERPES",
                via: "HERPESKRC20"
            });
            window.open("https://twitter.com/intent/tweet/?" + params.toString(), "_blank");
        }
    };
    document.getElementById("generate")?.addEventListener("click", generate);
    document.getElementById("swap-default")?.addEventListener("click", (_event)=>{
        $f43313d21d3fd8e2$var$switchMode((0, $4c0f0ee047d80e21$export$e0112074983e541d).DEFAULT);
    });
    document.getElementById("swap-twitter")?.addEventListener("click", (_event)=>{
        $f43313d21d3fd8e2$var$switchMode((0, $4c0f0ee047d80e21$export$e0112074983e541d).TWITTER);
    });
};
document.addEventListener("DOMContentLoaded", function() {
    $f43313d21d3fd8e2$var$boot();
});


//# sourceMappingURL=index.64bf9bfb.js.map
